/* dashboard-rediseno (15-oct-2026): A15, LAS DEMAS SE ACOMODAN EN 200 MS.

   ARCHIVO EN ASCII A PROPOSITO (regla de la casa para los `.js` nuevos).

   Cuando una tarjeta se va de la rejilla (borrada) las de despues cambian de celda de golpe:
   una rejilla no anima eso por si sola. Este gancho hace lo de siempre en estos casos: mide
   donde estaba cada celda (marcada con `data-celda`) antes del cambio y donde quedo despues;
   a la que se movio le pone un `transform` que la regresa a su lugar viejo y, en el cuadro
   siguiente, lo quita con una transicion de 200 ms. Solo se mide al cambiar `llave` (la lista
   de celdas), nunca en cada render. Con "reducir movimiento" no anima nada. */
import { useLayoutEffect, useRef } from 'react';

export const REACOMODO_MS = 200;

export function reducirMovimiento() {
  try {
    return typeof window !== 'undefined' && typeof window.matchMedia === 'function'
      && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch {
    return false;
  }
}

export function useReacomodo(rejillaRef, llave) {
  const antes = useRef(new Map());
  useLayoutEffect(() => {
    const rejilla = rejillaRef.current;
    if (!rejilla || !rejilla.children) return;
    const celdas = [...rejilla.children].filter((c) => c.hasAttribute && c.hasAttribute('data-celda'));
    const ahora = new Map();
    for (const c of celdas) {
      const r = c.getBoundingClientRect();
      ahora.set(c.getAttribute('data-celda'), { x: r.left, y: r.top });
    }
    const viejas = antes.current;
    antes.current = ahora;
    if (viejas.size === 0 || reducirMovimiento()) return;
    for (const c of celdas) {
      const id = c.getAttribute('data-celda');
      const de = viejas.get(id);
      const a = ahora.get(id);
      if (!de || !a) continue;
      const dx = de.x - a.x;
      const dy = de.y - a.y;
      if (Math.abs(dx) < 0.5 && Math.abs(dy) < 0.5) continue;
      c.style.transition = 'none';
      c.style.transform = `translate(${dx}px, ${dy}px)`;
      const soltar = () => {
        c.style.transition = `transform ${REACOMODO_MS}ms ease-out`;
        c.style.transform = '';
      };
      if (typeof window.requestAnimationFrame === 'function') window.requestAnimationFrame(() => window.requestAnimationFrame(soltar));
      else soltar();
    }
  }, [rejillaRef, llave]);
}
